'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _healthcheck = require('./remote/healthcheck');

exports.default = {
    fetchHealthCheckData: _healthcheck.HealthCheck.fetchHealthCheckData
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/healthcheck.js
// module id = +RB6
// module chunks = 60